import { HTMLAttributes, forwardRef } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/utils/cn';

const containerVariants = cva('mx-auto w-full', {
  variants: {
    size: {
      xs: 'max-w-md',
      sm: 'max-w-xl',
      md: 'max-w-3xl',
      lg: 'max-w-4xl',
      xl: 'max-w-6xl',
      '2xl': 'max-w-7xl',
      full: 'max-w-full',
    },
    padding: {
      none: '',
      sm: 'px-4',
      md: 'px-6',
      lg: 'px-8',
      xl: 'px-12',
    },
    center: {
      true: 'flex flex-col items-center',
      false: 'flex flex-col',
    },
    flex: {
      true: 'flex-1',
      false: '',
    },
  },
  defaultVariants: {
    size: 'md',
    padding: 'md',
    center: false,
    flex: true,
  },
});

export interface ContainerProps
  extends
    HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof containerVariants> {
  children: React.ReactNode;
}

export const Container = forwardRef<HTMLDivElement, ContainerProps>(
  ({ children, size, padding, center, flex, className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          containerVariants({ size, padding, center, flex }),
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);

Container.displayName = 'Container';

export { containerVariants };
